// ============================================================
// PanneauAssistant — l'assistant LÀ OÙ PHILIPPE FAIT SES DEVIS.
// ------------------------------------------------------------
// Un panneau latéral sur la page du devis, qui connaît le devis et la
// pièce sélectionnée : « pourquoi cette pièce est à ce prix ? » suffit.
// Il rouvre la dernière conversation de CE devis, ou en commence une au
// premier message. Replié par défaut : il ne prend pas de place au
// deviseur qui ne s'en sert pas.
// ============================================================

import { useEffect, useState } from 'react';
import Button from '../../ui/Button.jsx';
import api from '../../lib/api.js';
import Conversation from './Conversation.jsx';
import './assistant.css';

export function PanneauAssistant({ devisId, pieceId = null, pieceNom = null }) {
  const [ouvert, setOuvert] = useState(false);
  const [conversationId, setConversationId] = useState(null);

  useEffect(() => {
    if (!ouvert) return undefined;
    let vivant = true;
    api.get(`/assistant/conversations?devis_id=${devisId}`)
      .then((r) => { if (vivant) setConversationId(r.conversations?.[0]?.id ?? null); })
      .catch(() => {});
    return () => { vivant = false; };
  }, [ouvert, devisId]);

  if (!ouvert) {
    return (
      <Button className="assistant-panneau__ouvrir" variant="secondary" onClick={() => setOuvert(true)}>
        Demander à l’assistant
      </Button>
    );
  }
  return (
    <aside className="assistant-panneau" aria-label="Assistant">
      <div className="row row--between">
        <p className="caps">Assistant{pieceNom ? ` — ${pieceNom}` : ''}</p>
        <span>
          <Button size="sm" variant="ghost" onClick={() => setConversationId(null)}>Nouvelle</Button>
          <Button size="sm" variant="ghost" onClick={() => setOuvert(false)}>Fermer</Button>
        </span>
      </div>
      <Conversation
        key={conversationId ?? 'nouvelle'}
        conversationId={conversationId}
        devisId={devisId}
        pieceId={pieceId}
        onCree={setConversationId}
        exemples={pieceId
          ? ['Pourquoi cette pièce est à ce prix ?', 'Qu’a lu l’agent sur le plan de cette pièce ?', 'A-t-on déjà chiffré cette référence ?']
          : ['Résume ce devis.']}
      />
    </aside>
  );
}

export default PanneauAssistant;
